module.exports = __webpack_public_path__ + "static/media/CSIDlogo.58c546ba.png";